import React from 'react';
import moment from 'moment';
import 'whatwg-fetch';
import SubNavBar from '../SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiProductHardwareShow = '/api/stepProduction/getProductHardware/';
const apiProductVirtualShow = '/api/stepProduction/getProductVirtual/';
const apiStock = '/api/stock/';

class DisplayProduct extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalPostCustomerOpen: false,
      entity: undefined,
      isHardware: undefined,
      contactId: undefined,
      productSN: '____',
      productWording: '____',
      productStock: '____',
      productDate: '____',
      productSupplier: '____',
      productIsInstalled: undefined,
      productDateInstalled: undefined,
      productIsBilled: undefined,
      productDateBilled: undefined,
      stocks: undefined,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.loadStocks = this.loadStocks.bind(this);
    this.updateStock = this.updateStock.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (name === 'stock') {
      let stock = {
        id: parseInt(value),
      };
      this.updateStock(stock, 'entity', 'stock');
    } else {
      this.setState({
        [name]: value,
      });
    }
  }

  componentDidMount() {
    if (this.props.productType && this.props.match.params.id) {
      // check if id supplied in the route
      let isHardware = this.props.productType == 'hardware';
      let queryURL = isHardware ? apiProductHardwareShow : apiProductVirtualShow;

      let productId = this.props.match.params.id;

      let graphQueryHardware =
        'id, stickerId, dateDelivery, installed, dateInstalled, billed, dateBilled, reference{ id, wording, supplierHardware{ name } }, stock{ id, name }';
      let graphQueryVirtual = 'id, dateInstalled, installed, billed, reference{ id, wording, supplierVirtual{ name } }';
      let graphProduct = isHardware ? graphQueryHardware : graphQueryVirtual;
      let graphQL = '{ product(id:' + productId + '){ ' + graphProduct + '} }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['product']) {
              if (isHardware) {
                // we pick hardware properties
                this.setState({
                  isHardware: true,
                  productSN: data['data']['product']['stickerId'],
                  productDate: data['data']['product']['dateDelivery'],
                  productWording: data['data']['product']['reference']['wording'],
                  productSupplier: data['data']['product']['reference']['supplierHardware']['name'],
                  stock: data['data']['product']['stock']['id'],
                  productIsInstalled: data['data']['product']['installed'],
                  productDateInstalled: data['data']['product']['dateInstalled'],
                  productIsBilled: data['data']['product']['billed'],
                  productDateBilled: data['data']['product']['dateBilled'],
                });

                this.loadStocks();
              } else {
                // we pick virtual properties
                this.setState({
                  isHardware: false,
                  productSN: '#' + data['data']['product']['id'],
                  productWording: data['data']['product']['reference']['wording'],
                  productSupplier: data['data']['product']['reference']['supplierVirtual']['name'],
                  productIsInstalled: data['data']['product']['installed'],
                  productDateInstalled: data['data']['product']['dateInstalled'],
                  productIsBilled: data['data']['product']['billed'],
                  productDateBilled: data['data']['product']['dateBilled'],
                });
              }
            }
            //console.log(data);
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch Product entity: \n' + error);
          }.bind(this)
        );
    }
    ///////////////////////////////////////
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  loadStocks() {
    let queryURL = apiStock;
    let graphQL = '{ stocks{ id, name} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['stocks']) {
            this.setState({
              stocks: data['data']['stocks'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch stock list ' + error);
        }.bind(this)
      );
  }

  render() {
    return (
      <div id='appView' className='div-entity'>
        <SubNavBar goBack={this.props.history.goBack} title='Fiche Produit' />

        <div id='appViewContent'>
          <div className='entity-display'>
            <form>
              <div className='form-group'>
                <label htmlFor='inputName'>Numéro de série</label>
                <input
                  name='productSN'
                  value={this.state.productSN}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  id='inputName'
                  placeholder='Nom du contact'
                  readOnly
                />
              </div>
              <div className='form-group'>
                <label htmlFor='inputName'>Référence</label>
                <input
                  name='productWording'
                  value={this.state.productWording}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  id='inputName'
                  placeholder='Nom du contact'
                  readOnly
                />
              </div>
              <div className='form-group'>
                <label htmlFor='inputName'>Type</label>
                <input
                  name='productType'
                  value={this.state.isHardware ? 'Matériel' : 'Virtuel'}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  id='inputName'
                  placeholder='Nom du contact'
                  readOnly
                />
              </div>
              <div className='form-group'>
                <label htmlFor='inputName'>Fournisseur</label>
                <input
                  name='productSupplier'
                  value={this.state.productSupplier}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  id='inputName'
                  placeholder='Nom du contact'
                  readOnly
                />
              </div>
              {this.state.isHardware && (
                <div>
                  <div className='form-group'>
                    <label>Stock</label>
                    <select
                      name='stock'
                      value={this.state.stock}
                      onChange={this.handleInputChange}
                      className='form-control'
                    >
                      {this.state.stocks ? (
                        this.state.stocks.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))
                      ) : (
                        <span>Chargement...</span>
                      )}
                    </select>
                  </div>
                  <div className='form-group'>
                    <label htmlFor='inputName'>Rentré en stock le</label>
                    <input
                      name='productDate'
                      value={moment(this.state.productDate).format('DD-MM-YY à HH:mm')}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      id='inputName'
                      placeholder='Nom du contact'
                      readOnly
                    />
                  </div>
                </div>
              )}
              {this.state.productIsInstalled && (
                <div className='form-group'>
                  <label htmlFor='inputName'>Installé le</label>
                  <input
                    name='productDateInstalled'
                    value={moment(this.state.productDateInstalled).format('DD-MM-YY à HH:mm')}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    id='inputName'
                    placeholder='Nom du contact'
                    readOnly
                  />
                </div>
              )}
              {this.state.productIsBilled && (
                <div className='form-group'>
                  <label htmlFor='inputName'>Facturé le</label>
                  <input
                    name='productDateBilled'
                    value={moment(this.state.productDateBilled).format('DD-MM-YY à HH:mm')}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    id='inputName'
                    placeholder='Nom du contact'
                    readOnly
                  />
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  }

  updateStock(newValue, inputType, fieldName) {
    // !! Important-> the given "fieldName" attribute must be the name of the ORM attribute !!

    let newValueSent = newValue;
    let fieldNameEntity = '';
    if (inputType === 'text') {
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else if (inputType === 'entity') {
      newValueSent = JSON.stringify(newValue);
      fieldNameEntity = '{ id }';
    }

    let graphQL = 'mutation { product(id:' + this.props.match.params.id + ', ';
    graphQL += fieldName + ':' + newValueSent + ') { ' + fieldName + fieldNameEntity + ' } }';

    let queryURL = apiProductHardwareShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          console.log(data);
          let receivedValue = data['data']['product'][fieldName];
          // Pre transform
          if (inputType === 'entity') {
            receivedValue = JSON.stringify(receivedValue);
            newValue = JSON.stringify(newValue);
          }

          if (receivedValue == newValue) {
            this.props.openToast(true, 'Votre modification a bien été prise en compte.');
            this.componentDidMount();
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch UPDATE post entity ' + error);
        }.bind(this)
      );
  }
}

export default withAuth(DisplayProduct);
